import { render, staticRenderFns } from "./InputFormDataView.vue?vue&type=template&id=00adea0a&"
import script from "./InputFormDataView.vue?vue&type=script&lang=js&"
export * from "./InputFormDataView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports